module.exports = __webpack_public_path__ + "img/layout_side_panel_main.6b86ab07.webp";